// components/HOC/RequireSignIn.tsx
import React from 'react';
import { useAuth } from '../../module/AuthContext';
import { useDispatch } from 'react-redux';
import { Stack, SxProps, Theme, Typography } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import CustomButton from '../Button/CustomButton';
import { toggleAuthModal } from '../../redux/authentication/action';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';

interface RequireSignInProps {
    children: React.ReactNode;
    promptText?: string;
    sx?: SxProps<Theme>;
    textSx?: SxProps<Theme>;
}

const RequireSignIn: React.FC<RequireSignInProps> = ({ children, promptText = 'Sign in to continue.', sx, textSx }) => {
    const { isSignedIn } = useAuth();
    const dispatch = useDispatch();
    const { themeStyle } = useThemeContext();

    if (!isSignedIn) {
        return (
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                m={2}
                sx={{
                    position: 'relative',
                    backgroundColor: theme[themeStyle].form_gray,
                    padding: '15px',
                    borderRadius: 4,
                    border: `1px solid ${theme[themeStyle].tag_white}`,
                    ...sx,
                }}>
                <Typography
                    sx={{
                        fontFamily: FONT_ENUM.REGULAR_HEADER,
                        color: theme[themeStyle].tag_white,
                        fontSize: 12,
                        ...textSx,
                    }}>
                    {promptText}
                </Typography>
                <CustomButton
                    label="Sign In"
                    onClick={() => dispatch(toggleAuthModal(true))}
                    sx={{
                        mx: 1,
                        '&:hover': {
                            WebkitTextFillColor: theme[themeStyle].primary_orange,
                        },
                    }}
                    textStyle={{ fontSize: 12 }}
                    customStyle={{ height: 20 }}
                />
            </Stack>
        );
    }

    return <>{children}</>;
};

export default RequireSignIn;
